<form [formGroup]="form" class="flag-stop-form" id="flagStopForm">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="dismiss()" size="default" color="secondary" fill="outline">
        <ion-icon name="arrow-back"></ion-icon>
        <span class="hidden-md">&nbsp; {{ 'ACTION.back' | translate }}</span>
      </ion-button>
    </ion-buttons>
    @if (scheduledFlagStop?.id) {
      <ion-title role="heading" aria-level="2">
        <small>{{ 'LABEL.performScheduledStop' | translate }}</small>
        <br>{{ scheduledFlagStop.location }} @if (scheduledFlagStop.direction) {
          ({{ scheduledFlagStop.direction }})
        }
      </ion-title>
    }
    @if (!scheduledFlagStop?.id && locationName) {
      <ion-title role="heading" aria-level="2">
        <small>{{ 'LABEL.performScheduledStop' | translate }}</small>
        <br>{{ locationName }}
        </ion-title>
      }
      @if (!scheduledFlagStop?.id && !locationName) {
        <ion-title
          role="heading"
          aria-level="2"
          >
          {{ 'LABEL.performFlagStop' | translate }}
        </ion-title>
      }
    </ion-toolbar>


    <ion-content>
      <div class="content">
        <section class="card inputs odometer">
          <label id="odo" aria-describedby="odoError">{{ 'LABEL.odometer' | translate }}</label>
          <div
            aria-labelledby="odo"
            incrementControl
            [maxValue]="999999"
            [incName]="'LABEL.odometer' | translate"
            formControlName="odometer"
            [integerOnly]="true"
            >
            <form-error name="odometer" id="odoError" />
          </div>
        </section>

        <section class="card summary">
          <h3 class="header">Stop Summary</h3>
          <div class="body">
            <div class="cash">

              <div class="input-container">
                <div class="label" id="totalCashCollected">{{ 'LABEL.totalCashCollected' | translate }}</div>
                <ion-item fill="outline">
                  <app-currency
                    class="field"
                    placeholder="amount"
                    formControlName="totalCashCollected"
                    aria-labelledby="totalCashCollected"
                    aria-describedby="totalCashCollectedHint"
                    name="amount"
                    prefix="$"
                    />
                </ion-item>
                <form-error class="error" name="totalCashCollected" />
                <div id="totalCashCollectedHint" class="hint">
                  @if (showExpectedFare) {
                    <div>
                      {{ "LABEL.totalCashExpected" | translate }}: {{ totalCashExpected }}
                    </div>
                  }
                </div>
              </div>

              @if (paraPassEnabled) {
                <div class="total-passes">
                  <div class="label">{{ 'LABEL.scannedPasses' | translate }}</div>
                  <div class="field">{{ form.controls.scannedPasses.value.length }}</div>
                </div>
              }

              <hr class="accent">

              <div class="boarded">
                <div class="label">{{ 'LABEL.boardedHere' | translate }}</div>
                <div class="field">{{ form.controls.totalBoarded.value }}</div>
              </div>

              <div class="input-container">
                <div class="label" id="deboarded">{{ 'LABEL.deBoardedHere' | translate }}</div>
                <ion-item fill="outline">
                  <ion-input
                    class="field"
                    type="number"
                    formControlName="totalDeBoarded"
                    inputmode="numeric"
                    aria-labelledby="deboarded"
                    />
                </ion-item>
                <ion-button
                  class="increment"
                  type="button"
                  color="primary"
                  fill="outline"
                  [attr.aria-label]="'ACTION.add' | translate"
                  (click)="increment('totalDeBoarded')"
                  >
                  <ion-icon name="add" />
                </ion-button>
                <form-error class="error" name="totalDeBoarded" [customMessage]="{ decimal: wholeNumberError }" />
              </div>
            </div>

            <hr>

              <div class="boarded total">
                <div class="label">{{ (environment.features.onlyFixedPassengersInCount ? 'LABEL.fixedPassengersOnBoard' : 'LABEL.totalPassengersOnBoard') | translate }}</div>
                <div class="field">{{ totalPassengersOnBoard }}</div>
                @if (totalPassengersOnBoard < 0) {
                  <div role="alertdialog" class="warning">
                    <ion-icon name="warning" />
                    {{ 'MESSAGE.negativePassengerCount' | translate }}
                  </div>
                }
              </div>

            </div>
          </section>

          @if (paraPassEnabled) {
            <section class="passes" aria-label="passes">
              <div class="body" >
                <ion-button
                  color="secondary"
                  type="button"
                  expand="block"
                  (click)="onboardWithPass(false, false)"
                  >
                  {{ 'LABEL.onboardPass' | translate }}
                </ion-button>
                @if (rapidPassEnabled) {
                  <div class="rapid-pass">
                    <ion-button
                      color="tertiary"
                      type="button"
                      expand="block"
                      (click)="onboardWithPass(true, false)"
                      >
                      {{ 'LABEL.rapidOnboardTablet' | translate }}
                    </ion-button>
                    <ion-button
                      color="tertiary"
                      fill="outline"
                      type="button"
                      expand="block"
                      (click)="onboardWithPass(true, true)"
                      >
                      {{ 'LABEL.rapidOnboardBluetooth' | translate }}
                    </ion-button>
                  </div>
                }
              </div>
            </section>
          }

          <section class="card passless">
            <h3 class="header">
              @switch (features.stopRiderType) {
                @case ('fareTypes') {
                  {{ 'LABEL.fareTypes' | translate }}
                }
                @case ('riderTypes') {
                  {{ 'LABEL.passlessBoarding' | translate }}
                }
                @default {
                  {{ features.stopRiderType }}
                }
              }
            </h3>
            <div class="body" formGroupName="types">
              @for (type of types; track type) {
                <div class="type">
                  <div class="label" [id]="type.formControlName + '-label'">
                    {{ type.label }}
                    @if (type.fare) {
                      <span class="fare">{{ type.fare | currency }} {{ 'LABEL.perRider' | translate }}</span>
                    }
                  </div>
                  <ion-item fill="outline">
                    <ion-input
                      class="field"
                      type="number"
                      [formControlName]="type.formControlName"
                      inputmode="numeric"
                      [attr.aria-labelledby]="type.formControlName + '-label'"
                      />
                  </ion-item>
                  <ion-button
                    class="increment"
                    type="button"
                    color="primary"
                    fill="outline"
                    [attr.aria-label]="'ACTION.add' | translate"
                    (click)="increment('types.' + type.formControlName)"
                    >
                    <ion-icon name="add" />
                  </ion-button>
                  <form-error class="error" [name]="type.formControlName" [customMessage]="{ decimal: wholeNumberError }" />
                </div>
              }
            </div>
          </section>
        </div>


      </ion-content>

      <ion-footer>


        <ion-button
          color="primary"
          expand="block"
          (click)="completeFlagStopClicked()"
          [disabled]="totalPassengersOnBoard < 0 || form.invalid">
          {{ 'LABEL.completeStop' | translate }}
          <ion-icon name="checkmark" slot="end"></ion-icon>
        </ion-button>

      </ion-footer>
    </form>
